module.exports = __webpack_public_path__ + "static/media/essve-icons.da7f1c33.jpg";